import React from 'react';
import { FileText, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const TEMPLATE_ICONS = {
  announcement: '📢',
  practice: '📋',
  registration: '⏰',
  event: '📅',
  custom: '⭐',
};

const TemplatesCard = ({ templates, onLoad, onDelete }) => (
  <Card className="templates-card">
    <CardHeader>
      <CardTitle className="email-card-title">
        <FileText size={20} />
        Quick Templates
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="templates-list">
        {templates.map((template) => (
          <div
            key={template.id}
            className="template-btn"
            onClick={() => onLoad(template)}
            role="button"
            tabIndex={0}
            data-testid={`template-${template.id}`}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
          >
            <span className="template-icon">{TEMPLATE_ICONS[template.template_type]}</span>
            <span style={{ flex: 1 }}>
              {template.name}
              {!template.builtin && (
                <span style={{ marginLeft: 6, fontSize: '0.7rem', color: '#FFD700', opacity: 0.75 }}>
                  (saved)
                </span>
              )}
            </span>
            {!template.builtin && (
              <button
                type="button"
                onClick={(e) => onDelete(template, e)}
                title="Delete template"
                data-testid={`delete-template-${template.id}`}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#ef4444',
                  cursor: 'pointer',
                  padding: '2px 4px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Trash2 size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default TemplatesCard;
